import { KeyboardEvent, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LoginFormContext } from "../login-form.context";
import { EyeIcon, EyeSlashIcon, IconButtonComponent, TextFieldComponent } from "@gx1/gx-ui-common";
import styles from "./login-form-fields.module.scss";

const LoginFormFields = ({ onSubmit }: { onSubmit: () => void }) => {
  const { t } = useTranslation();
  const { email, password, showPassword, setEmail, setPassword, setShowPassword } = useContext(LoginFormContext);

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      setEmail("");
      setPassword("");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [setEmail, setPassword]);

  return (
    <div className={styles.loginFields}>
      <TextFieldComponent
        inputProps={{ autoComplete: "username" }}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={(e) => handleKeyDown(e)}
        placeholder={t("Email")}
        rootClassName={"gx-dragon-username-input"}
        value={email}
      />
      <TextFieldComponent
        inputProps={{ autoComplete: "current-password" }}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={(e) => handleKeyDown(e)}
        placeholder={t("Password")}
        rootClassName={"gx-dragon-password-input"}
        InputProps={{ type: showPassword ? "text" : "password" }}
        value={password}
        endIcon={
          <IconButtonComponent
            aria-label={showPassword ? t("Hide password") : t("Show password")}
            onClick={() => setShowPassword(!showPassword)}
            size={"small"}
          >
            {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
          </IconButtonComponent>
        }
      />
    </div>
  );
};
export default LoginFormFields;
